<script lang="ts">
    // @ts-nocheck
    import tabIcon from "@/assets/healthy_medicine_grey.svg";
    import BaseTab from "@/tabs/mixins/BaseTab.js";

    export default {
        name: "receptforskrivningsmallar",
        tabName: "Förskrivningsmallar",
        extends: BaseTab,
        patientBound: false,
        icon: tabIcon,
    };
</script>

<script setup lang="ts">
    import KTag from "@/components/KTag.vue";
    import { hasPrescriptionRight } from "@/tabs/Receptforskrivning/helpers";
    import ReceptforskrivningMallList from "@/tabs/Receptforskrivning/Mall/List/ReceptforskrivningMallList.vue";
    import { useStore } from "@/store";
    import { computed } from "vue";

    const store = useStore();

    const profile = computed(() => store.getters["userData/currentProfile"]);
    const hasFullAccess = computed(
        () => store.getters["userData/is_superuser"] || store.getters["userData/is_verksamhetsadmin"]
    );
</script>

<template>
    <div class="receptforskrivning-mallar">
        <div class="header">
            <h2>Förskrivningsmallar</h2>
            <KTag variant="info" contentDirection="horizontal" size="large">
                Förskrivningsmallar är sparade uppgifter som kan användas för att förifylla en ny förskrivning
            </KTag>
        </div>
        <template v-if="hasPrescriptionRight(profile) || hasFullAccess">
            <ReceptforskrivningMallList />
        </template>
        <template v-else>
            <div>
                <KTag variant="warning" contentDirection="horizontal" size="large"
                    >Du har inte rätt att hämta och använda förskrivningsmallar</KTag
                >
            </div>
        </template>
    </div>
</template>

<style scoped lang="scss">
    @import "@/style/variables";

    .receptforskrivning-mallar {
        display: flex;
        flex-direction: column;
        gap: $row-gap;

        .header {
            display: flex;
            flex-direction: column;
            gap: 0.3rem;
        }
    }
</style>
